class TopBg {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector(this.el)) {
      this.event();
    }
  }
  event() {
    const Bg = document.querySelector(this.el);
    const BgWrap = document.querySelector('.js-top-bg-wrap');
    gsap.to(Bg,{
      borderRadius: 0,
      scale: 1,
      opacity: 0.3,
      scrollTrigger: {
        trigger: Bg,
        start: 'top center',
        end: 'top top',
        scrub: 0.1
      }
    })
    ScrollTrigger.create({
      trigger: BgWrap,
      start: 'top top',
      end: 'bottom top',
      toggleActions: 'play none reverse none',
      onEnter: () => {
        Bg.style.position = 'fixed';
        Bg.style.top = '0';
      },
      onLeaveBack: () => {
        Bg.style.position = '';
        Bg.style.top = '';
      }
    });
  }
}